import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

const Context = createContext(null);
const CART_KEY = "mases-cart-v1";
const readCart = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(CART_KEY) || "[]");
    if (!Array.isArray(saved)) return [];
    return saved.filter(x => x && typeof x.sku === "string" && Number.isInteger(x.qty) && x.qty > 0 && x.qty <= 100000).map(({sku, qty}) => ({sku, qty}));
  } catch { return []; }
};
export const CommerceProvider = ({ children }) => {
  const [user, setUser] = useState(null), [authReady, setAuthReady] = useState(false);
  const [products, setProducts] = useState([]), [catalogReady, setCatalogReady] = useState(false), [catalogError, setCatalogError] = useState("");
  const [cart, setCart] = useState(readCart), [cartOpen, setCartOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false), [quoteOpen, setQuoteOpen] = useState(false);
  const refreshProducts = () => api.get("/products").then(r => {setProducts(r.data.products);setCatalogError("");}).catch(() => setCatalogError("Katalog belum dapat dimuat. Silakan coba lagi.")).finally(() => setCatalogReady(true));
  useEffect(() => { refreshProducts(); api.get("/auth/me").then(r => setUser(r.data)).catch(() => {}).finally(() => setAuthReady(true)); }, []);
  useEffect(() => { try {localStorage.setItem(CART_KEY, JSON.stringify(cart));} catch {toast.error("Keranjang tidak dapat disimpan di browser ini.");} }, [cart]);
  const cartItems = cart.map(item => ({...products.find(p => p.sku === item.sku), ...item})).filter(p => p.name);
  const total = cartItems.reduce((sum, item) => sum + item.price * item.qty, 0);
  const add = (product, quantity = 1) => {
    const existing = cart.find(item => item.sku === product.sku)?.qty || 0;
    if (!Number.isInteger(quantity) || quantity < 1 || existing + quantity > product.stock) return toast.error("Jumlah melebihi stok tersedia");
    setCart(old => old.some(item => item.sku === product.sku) ? old.map(item => item.sku === product.sku ? {...item, qty: item.qty + quantity} : item) : [...old, {sku: product.sku, qty: quantity}]);
    toast.success("Produk ditambahkan ke keranjang");
  };
  const changeQty = (sku, quantity) => {
    const product = products.find(p => p.sku === sku);
    if (quantity > (product?.stock || 0)) return toast.error("Jumlah melebihi stok tersedia");
    setCart(old => quantity <= 0 ? old.filter(p => p.sku !== sku) : old.map(p => p.sku === sku ? {...p, qty: quantity} : p));
  };
  return <Context.Provider value={{user, setUser, authReady, products, catalogReady, catalogError, refreshProducts, cart, setCart, cartItems, total, add, changeQty, cartOpen, setCartOpen, authOpen, setAuthOpen, quoteOpen, setQuoteOpen}}>{children}</Context.Provider>;
};
export const useCommerce = () => useContext(Context);